// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + {"56":"3fc5a981eb115b218ae6","125":"178e96ff79bbbf3d1804","254":"f2a3d3a5a6913e877ad0","318":"a1a510cf38ecfd4c4462","540":"cab4c73b36ec851241d1","675":"7ca0deea6878d9954815","848":"d28cda3f3985c70670e4","961":"b0ae53da9d29635f2a46"}[chunkId] + ".js";
};